
import VueSlickCarousel from 'vue-slick-carousel'

export default {
  components: {
    VueSlickCarousel,
  },
  props: {
    blok: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      carouselName: `carousel-${this.blok._uid}`,
      carouselActiveSlide: 0,
      carouselOptions: {
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        centerMode: false,
        pauseOnHover: true,
        autoplay: !!this.blok.autoplay,
        autoplaySpeed: this.blok.autoplaySpeed
          ? parseInt(this.blok.autoplaySpeed)
          : 5000,
        cssEase: 'ease',
        responsive: [],
      },
    }
  },
  methods: {
    carouselGoToSlide(index) {
      this.$refs[this.carouselName].goTo(index)
    },
    carouselAfterChange(index) {
      this.carouselActiveSlide = index
    },
    carouselTabsMouseEnter() {
      if (!this.blok.autoplay) {
        return false
      }
      this.$refs[this.carouselName].pause()
    },
    carouselTabsMouseLeave() {
      if (!this.blok.autoplay) {
        return false
      }
      this.$refs[this.carouselName].play()
    },
  },
}
